import * as React from 'react';
import { FC } from 'react';

import { Platform, UIManager } from 'react-native';

import { LayoutContainer } from 'components/layout/styled';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import { LoyaltyCtaBar } from '../loyalty-cta-bar';

import { LoyaltyRewardsContent } from './loyalty-rewards-content';
import { ILoyaltyRewardsViewProps } from './types';

if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

export const LoyaltyRewardsView: FC<React.PropsWithChildren<ILoyaltyRewardsViewProps>> = ({
  handleOnPress,
  sanityRewardsMap,
  selectedCategories,
  setSelectedCategories,
  engineRewardsMap,
  rewardCategories,
  rewardsEvaluationMap,
  title,
  selectedReward,
  refetchRewards,
  isRefreshingRewards,
  isWidget,
  setSelectedRewardIdFromWidget,
}) => {
  const isMobile = useIsMobileBreakpoint();

  return (
    <LayoutContainer isFullContainer={isMobile}>
      <LoyaltyCtaBar />
      <LoyaltyRewardsContent
        selectedReward={selectedReward}
        refetchRewards={refetchRewards}
        isRefreshingRewards={isRefreshingRewards}
        engineRewardsMap={engineRewardsMap}
        isWidget={isWidget}
        rewardCategories={rewardCategories}
        setSelectedRewardIdFromWidget={setSelectedRewardIdFromWidget}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        handleOnPress={handleOnPress}
        sanityRewardsMap={sanityRewardsMap}
        rewardsEvaluationMap={rewardsEvaluationMap}
        title={title}
      />
    </LayoutContainer>
  );
};
